module.exports = {
  messages: {
    A11Y_LOGO: 'Go to XING homepage',
    A11Y_SETTINGS_DROPDOWN_LABEL: 'Edit settings',
    ACCOUNT_FORMS_PASSWORD_STRENGTH_0: 'Your password is really easy to guess.',
    ACCOUNT_FORMS_PASSWORD_STRENGTH_1: 'Your password is really easy to guess.',
    ACCOUNT_FORMS_PASSWORD_STRENGTH_2: 'Your password is quite easy to guess.',
    ACCOUNT_FORMS_PASSWORD_STRENGTH_3:
      'Add a few more characters just to be on the safe side.',
    ACCOUNT_FORMS_PASSWORD_STRENGTH_4: "That's a decent password.",
    ACCOUNT_FORMS_PASSWORD_STRENGTH_5: 'This is a great password!',
    ACCOUNT_FORMS_PASSWORD_STRENGTH_6:
      "Passwords don't get much better than this!",
    ACCOUNT_FORMS_PASSWORD_STRENGTH_LESS_THAN:
      'Please make sure your password contains at least 8 characters.',
    ACCOUNTS_CHANGE_PHONE_ACTIVATION_SMS_TEXT:
      '{code} is your XING activation code.',
    ACCOUNTS_SETTINGS_ERROR_PENDING_EMAIL_ERROR:
      "Sorry, that didn't work. Please try again.",
    ACTIVE_LANGUAGE: 'English',
    ARMSTRONG_DISCO_NAVIGATION_ICON_TEXT: 'Exchange',
    BUTTON_BACK: 'Back',
    BUTTON_CANCEL: 'Cancel',
    BUTTON_EDIT: 'Edit',
    BUTTON_NEXT: 'Next',
    BUTTON_SAVE: 'Save',
    BUTTON_SEND_CONFIRMATION_EMAIL: 'Resend',
    BUTTON_TRY_AGAIN: 'Try again',
    COUNTRY_LIST:
      "ad\\tAndorra\nae\\tUnited Arab Emirates\naf\\tAfghanistan\nag\\tAntigua and Barbuda\nal\\tAlbania\nam\\tArmenia\nan\\tNetherlands Antilles\nao\\tAngola\naq\\tAntarctica\nar\\tArgentina\nat\\tAustria\nau\\tAustralia\naz\\tAzerbaijan\nba\\tBosnia and Herzegovina\nbd\\tBangladesh\nbe\\tBelgium\nbf\\tBurkina Faso\nbg\\tBulgaria\nbh\\tBahrain\nbi\\tBurundi\nbj\\tBenin\nbm\\tBermuda\nbn\\tBrunei Darussalam\nbo\\tBolivia\nbr\\tBrazil\nbs\\tBahamas\nbt\\tBhutan\nbw\\tBotswana\nby\\tBelarus\nca\\tCanada\ncd\\tCongo, The Democratic Republic of the\ncf\\tCentral African Republic\ncg\\tCongo\nch\\tSwitzerland\nci\\tIvory Coast\ncl\\tChile\ncm\\tCameroon\ncn\\tChina\nco\\tColombia\ncr\\tCosta Rica\ncu\\tCuba\ncv\\tCape Verde\ncy\\tCyprus\ncz\\tCzech Republic\nde\\tGermany\ndj\\tDjibouti\ndk\\tDenmark\ndo\\tDominican Republic\ndz\\tAlgeria\nec\\tEcuador\nee\\tEstonia\neg\\tEgypt\nes\\tSpain\net\\tEthiopia\nfi\\tFinland\nfr\\tFrance\nga\\tGabon\ngb\\tUnited Kingdom\nge\\tGeorgia\ngf\\tFrench Guiana\ngh\\tGhana\ngi\\tGibraltar\ngl\\tGreenland\ngm\\tGambia\ngn\\tGuinea\ngp\\tGuadeloupe\ngq\\tEquatorial Guinea\ngr\\tGreece\ngt\\tGuatemala\ngw\\tGuinea-Bissau\ngy\\tGuyana\nhk\\tHong Kong\nhn\\tHonduras\nhr\\tCroatia\nht\\tHaiti\nhu\\tHungary\nid\\tIndonesia\nie\\tIreland\nil\\tIsrael\nin\\tIndia\niq\\tIraq\nir\\tIran, Islamic Republic of\nis\\tIceland\nit\\tItaly\njm\\tJamaica\njo\\tJordan\njp\\tJapan\nke\\tKenya\nkg\\tKyrgyzstan\nkh\\tCambodia\nkm\\tComoros\nkp\\tNorth Korea\nkr\\tSouth Korea\nkw\\tKuwait\nkz\\tKazakhstan\nla\\tLao People's Democratic Republic\nlb\\tLebanon\nlc\\tSaint Lucia\nli\\tLiechtenstein\nlk\\tSri Lanka\nlr\\tLiberia\nls\\tLesotho\nlt\\tLithuania\nlu\\tLuxembourg\nlv\\tLatvia\nma\\tMorocco\nmc\\tMonaco\nmd\\tMoldova\nmg\\tMadagascar\nmk\\tMacedonia\nml\\tMali\nmn\\tMongolia\nmo\\tMacau\nmq\\tMartinique\nmr\\tMauritania\nmt\\tMalta\nmu\\tMauritius\nmv\\tMaldives\nmw\\tMalawi\nmx\\tMexico\nmy\\tMalaysia\nmz\\tMozambique\nna\\tNamibia\nnc\\tNew Caledonia\nne\\tNiger\nng\\tNigeria\nni\\tNicaragua\nnl\\tNetherlands\nno\\tNorway\nnp\\tNepal\nnz\\tNew Zealand\nom\\tOman\npa\\tPanama\npe\\tPeru\npf\\tFrench Polynesia\npg\\tPapua New Guinea\nph\\tPhilippines\npk\\tPakistan\npl\\tPoland\npr\\tPuerto Rico\npt\\tPortugal\npy\\tParaguay\nro\\tRomania\nru\\tRussian Federation\nrw\\tRwanda\nsa\\tSaudi Arabia\nsb\\tSolomon Islands\nsc\\tSeychelles\nsd\\tSudan\nse\\tSweden\nsg\\tSingapore\nsi\\tSlovenia\nsk\\tSlovakia\nsl\\tSierra Leone\nsm\\tSan Marino\nsn\\tSenegal\nso\\tSomalia\nsr\\tSuriname\nsv\\tEl Salvador\nsy\\tSyrian Arab Republic\nsz\\tEswatini\ntd\\tChad\ntg\\tTogo\nth\\tThailand\ntn\\tTunisia\ntr\\tTurkey\ntt\\tTrinidad and Tobago\ntw\\tTaiwan\ntz\\tTanzania\nua\\tUkraine\nug\\tUganda\nus\\tUnited States of America\nuy\\tUruguay\nuz\\tUzbekistan\nva\\tHoly See\nve\\tVenezuela\nvn\\tVietnam\nye\\tYemen\nza\\tSouth Africa\nzm\\tZambia\nzw\\tZimbabwe",
    COUNTRY_LIST_EXTENDED:
      'as\\tAmerican Samoa\nai\\tAnguilla\naw\\tAruba\nbb\\tBarbados\nbz\\tBelize\nky\\tCayman Islands\nck\\tCook Islands\ndm\\tDominica\ner\\tEritrea\nfo\\tFaroe Islands\nfj\\tFiji\ngd\\tGrenada\ngu\\tGuam\nvg\\tVirgin Islands, British\nvi\\tVirgin Islands, U.S.\nqa\\tQatar\nki\\tKiribati\nly\\tLibya\nmp\\tNorthern Mariana Islands\nmh\\tMarshall Islands\nyt\\tMayotte\nfm\\tMicronesia, Federated States of\nms\\tMontserrat\nnr\\tNauru\nnu\\tNiue\nnf\\tNorfolk Island\nom\\tOman\npw\\tPalau\nre\\tRéunion\nkn\\tSaint Kitts and Nevis\npm\\tSaint Pierre et Miquelon\nvc\\tSaint Vincent and the Grenadines\nws\\tSamoa\nsh\\tSaint Helena\nst\\tSao Tome and Principe\ntj\\tTajikistan\ntk\\tTokelau\ntl\\tTimor-Leste\nto\\tTonga\ntm\\tTurkmenistan\ntc\\tTurks and Caicos Islands\ntv\\tTuvalu\nvu\\tVanuatu\nwf\\tWallis and Futuna\ncx\\tChristmas Island\nmm\\tMyanmar\nrs\\tSerbia\nme\\tMontenegro\ngg\\tGuernsey\nsj\\tSvalbard and Jan Mayen Island\nhm\\tHeard Island and McDonald Islands\nbv\\tBouvet Island\nps\\tOccupied Palestine\npn\\tPitcairn Islands\num\\tUnited States Minor Outlying Islands\ntf\\tFrench Southern and Antarctic Lands\ngs\\tSouth Georgia and the South Sandwich Islands\neh\\tWestern Sahara\nfk\\tFalkland Islands\nax\\tÅland Islands\nje\\tJersey                                 \ncc\\tCoconut Islands   \nio\\tBritish Indian Ocean Territory\nim\\tIsle of Man\nbl\\tSaint-Barthélemy\nbq\\tBonaire, Sint Eustatius and Saba\ncw\\tCuraçao\nmf\\tSaint-Martin (French part)\nss\\tSouth Sudan\nsx\\tSint Maarten (Dutch part)\nxk\\tKosovo',
    CRATE_LOGIN_HEADLINE_HIDDEN_JOBS:
      "Log in now and discover jobs you won't find anywhere else.",
    EMAIL_REG_NEWSLETTER_HINT:
      'My e-mail address will only be used by XING and will not be forwarded to third parties. I can choose if I want to receive newsletters and recommendations.',
    ERROR_LOGIN:
      'Your login details are incorrect. Please check them and try again. <a href="https://login.xing.com/recovery">Having problems logging in?</a>',
    ERROR_LOGIN_COOKIE:
      'Your browser cookies could not be recognized. You need to activate cookies to log in. Please check this and try again.',
    ERROR_LOGIN_UNCONFIRMED:
      'This username is currently unconfirmed. Please check for the confirmation e-mail and click on the appropriate link within to confirm your username and activate your account. Click <a class="o11" href="/app/user?op=reconfirm&user_name={+UN}">here</a> to re-send the confirmation e-mail.',
    ERROR_PROFILE_OLD_PASSWORD: 'The password entered is wrong.',
    ERROR_REGISTER_EMAIL_REG:
      'We already know this e-mail address. Perhaps you already registered? If so, just log in now.',
    ERROR_REGISTER_EMAIL_SECONDARY:
      'Please check the information below about this e-mail address.',
    ERROR_REGISTER_PASSWORD_EMAIL_RAILS:
      'For your own security you should choose a password different to your e-mail address.',
    ERROR_REGISTER_PASSWORD_FN_RAILS:
      'For your own security you should choose a password different to your first name.',
    ERROR_REGISTER_PASSWORD_LN_RAILS:
      'For your security, do not use your last name as your password.',
    ERROR_REGISTER_PASSWORD_RAILS:
      'Please select a password (min. 8 characters).',
    ERROR_REGISTER_PASSWORD_UN:
      'For your own security you should choose a different password',
    FOOTER_LANGUAGES: 'Language',
    FRAME_HEADER_UPSELL_PREMIUM: 'Go Premium',
    FRAME_HEADER_UPSELL_PROJOBS: 'Check out ProJobs',
    HEADER_LOGIN_EMAIL: 'E-mail address',
    HEADER_LOGIN_EMAIL_LOST: 'Problems with your e-mail address',
    HEADER_LOGIN_EMAIL_OR_PHONE_LOST: 'Other problems logging in',
    HEADER_LOGIN_EMAIL_PHONE: 'E-mail',
    HEADER_LOGIN_LAND: 'Country',
    HEADER_LOGIN_PASSWORD: 'Password',
    HEADER_LOGIN_PASSWORD_LOST: 'Problems logging in',
    HEADER_LOGIN_PHONE: 'Mobile number',
    HEADER_LOGIN_WITH_EMAIL: 'Log in with e-mail address',
    HEADER_LOGIN_WITH_PHONE: 'Log in with mobile number',
    HEADER_SKIP_NAVIGATION: 'Skip navigation',
    LOGIN_ACCOUNT_LOGIN_ATTEMPTS_LIMIT_REACHED:
      'You tried to log in too many times. Please try again in 10 minutes.',
    LOGIN_ACCOUNT_LOGIN_ATTEMPTS_LIMIT_REACHED_SMS:
      "For security reasons, you can't send any more SMS codes right now. Please try again in 1 hour.",
    LOGIN_ACCOUNT_RECOVERY_ACTIVE_CREDENTIAL_NOT_FOUND_ERROR:
      "Sorry, that account doesn't seem to exist.",
    LOGIN_ACCOUNT_RECOVERY_ACTIVE_CREDENTIAL_NOT_PROVIDED_ERROR:
      'Please enter the e-mail address or mobile number you use for XING.',
    LOGIN_ACCOUNT_RECOVERY_CODE_INVALID:
      'For security reasons, this code is only valid for a limited time and has now expired. Please request a new code.',
    LOGIN_ACCOUNT_RECOVERY_DESCRIPTION:
      "Don't worry! We can verify your identity so you can change your login e-mail address.",
    LOGIN_ACCOUNT_RECOVERY_FILE_UPLOAD_ADD_LABEL: 'Upload document',
    LOGIN_ACCOUNT_RECOVERY_FILE_UPLOAD_CHANGE_LABEL: 'Change document',
    LOGIN_ACCOUNT_RECOVERY_FILE_UPLOAD_EXPIRATION:
      'How long will this photo be saved for?',
    LOGIN_ACCOUNT_RECOVERY_FILE_UPLOAD_EXPIRATION_PARAGRAPH:
      "We'll only use these images to verify your identity and will delete them after 30 days at the latest.",
    LOGIN_ACCOUNT_RECOVERY_FILE_UPLOAD_EXPIRATION_TITLE:
      'How long will this photo be saved for?',
    LOGIN_ACCOUNT_RECOVERY_FILE_UPLOAD_HOW_TO: 'Tips on uploading documents',
    LOGIN_ACCOUNT_RECOVERY_FILE_UPLOAD_HOW_TO_BACKSIDE: 'Rear',
    LOGIN_ACCOUNT_RECOVERY_FILE_UPLOAD_HOW_TO_BLURRY: 'Blurry',
    LOGIN_ACCOUNT_RECOVERY_FILE_UPLOAD_HOW_TO_COVERED: 'Covered up',
    LOGIN_ACCOUNT_RECOVERY_FILE_UPLOAD_HOW_TO_CUTAWAY: 'Cut off',
    LOGIN_ACCOUNT_RECOVERY_FILE_UPLOAD_HOW_TO_LIKE_SO:
      'Please upload your image like this:',
    LOGIN_ACCOUNT_RECOVERY_FILE_UPLOAD_HOW_TO_NO_NO:
      "Please don't upload your image like this:",
    LOGIN_ACCOUNT_RECOVERY_FILE_UPLOAD_HOW_TO_READABLE: 'Readable',
    LOGIN_ACCOUNT_RECOVERY_FILE_UPLOAD_HOW_TO_SHARP: 'Clear',
    LOGIN_ACCOUNT_RECOVERY_FILE_UPLOAD_HOW_TO_UPSIDE_DOWN: 'Upside down',
    LOGIN_ACCOUNT_RECOVERY_FILE_UPLOAD_MAX_SIZE:
      '(png, jpeg or bmp / max 5 MB)',
    LOGIN_ACCOUNT_RECOVERY_FILE_UPLOAD_MISSING_ERROR:
      'Please select a photo to continue.',
    LOGIN_ACCOUNT_RECOVERY_FILE_UPLOAD_REMOVE_LABEL: 'Delete document',
    LOGIN_ACCOUNT_RECOVERY_FILE_UPLOAD_SIZE_EXCEEDED_ERROR:
      'Please select a file up to 5 MB in size.',
    LOGIN_ACCOUNT_RECOVERY_FILE_UPLOAD_TYPE_NOT_ACCEPTED_ERROR:
      'Please select a file in JPG or PNG format.',
    LOGIN_ACCOUNT_RECOVERY_GENERIC_ERROR:
      'Sorry, something  went wrong. Please try again later.',
    LOGIN_ACCOUNT_RECOVERY_ID_UPLOAD_DESCRIPTION:
      'This step serves to protect your data: Upload a photo of the front of your ID card or driving licence. ',
    LOGIN_ACCOUNT_RECOVERY_ID_UPLOAD_TITLE: 'Verify your identity',
    LOGIN_ACCOUNT_RECOVERY_IMAGE_NOT_PROVIDED_ERROR:
      'Please upload a photo so we can verify your identity.',
    LOGIN_ACCOUNT_RECOVERY_INPUT_LABEL: 'Your previous e-mail',
    LOGIN_ACCOUNT_RECOVERY_INVALID_SESSION:
      'Sorry, something went wrong. Please try again.',
    LOGIN_ACCOUNT_RECOVERY_LINK_INVALID:
      'For security reasons, this link is only valid for a limited time and has now expired. Please request a new link.',
    LOGIN_ACCOUNT_RECOVERY_LOGIN_REQUIRED:
      "Unfortunately we couldn't find your request to reset your account. Please submit a new one.",
    LOGIN_ACCOUNT_RECOVERY_NEW_EMAIL_DESCRIPTION:
      'What e-mail address would you like to use to log in to XING from now on?',
    LOGIN_ACCOUNT_RECOVERY_NEW_EMAIL_INPUT_LABEL: 'Your new e-mail address',
    LOGIN_ACCOUNT_RECOVERY_NEW_EMAIL_INVALID_ERROR:
      'Please check your e-mail address again.',
    LOGIN_ACCOUNT_RECOVERY_NEW_EMAIL_NOT_PROVIDED_ERROR:
      'Please enter the e-mail address you want to use to log in to XING from now on.',
    LOGIN_ACCOUNT_RECOVERY_NEW_EMAIL_TITLE: 'Change e-mail address',
    LOGIN_ACCOUNT_RECOVERY_NEW_EMAIL_UNAVAILABLE_ERROR:
      'This e-mail address is already listed in our system. Please try using it to log in or to reset your password.',
    LOGIN_ACCOUNT_RECOVERY_NEW_EMAIL_UNAVAILABLE_ERROR_LINK: 'Log in now',
    LOGIN_ACCOUNT_RECOVERY_REQUEST_LIMIT_REACHED:
      "You've tried to recover your account too many times. Please wait at least 12 hours before trying again.",
    LOGIN_ACCOUNT_RECOVERY_RESET_REQUEST_ALREADY_OPEN_ERROR:
      'Please confirm your existing account recovery request.',
    LOGIN_ACCOUNT_RECOVERY_RESET_REQUEST_IN_PROCESS:
      'You already have a pending request to reset your account. Please wait until we contact you.',
    LOGIN_ACCOUNT_RECOVERY_SEARCH_CRITERIA_BIRTHDATE_LABEL: 'Date of birth',
    LOGIN_ACCOUNT_RECOVERY_SEARCH_CRITERIA_CITY_LABEL: 'City (optional)',
    LOGIN_ACCOUNT_RECOVERY_SEARCH_CRITERIA_EMAIL_1_LABEL:
      'E-mail address 1 (optional)',
    LOGIN_ACCOUNT_RECOVERY_SEARCH_CRITERIA_EMAIL_2_LABEL:
      'E-mail address 2 (optional)',
    LOGIN_ACCOUNT_RECOVERY_SEARCH_CRITERIA_EMAILS_EXPLANATION:
      'Try entering all the e-mail addresses you might have used to register with XING.',
    LOGIN_ACCOUNT_RECOVERY_SEARCH_CRITERIA_FIRSTNAME_LABEL: 'First name',
    LOGIN_ACCOUNT_RECOVERY_SEARCH_CRITERIA_LASTNAME_LABEL: 'Last name',
    LOGIN_ACCOUNT_RECOVERY_SEARCH_CRITERIA_TITLE:
      'Forgotten your e-mail address?',
    LOGIN_ACCOUNT_RECOVERY_SUCCESS_FURTHER_QUESTIONS:
      'Questions? Just get in touch with us.',
    LOGIN_ACCOUNT_RECOVERY_SUCCESS_PARAGRAPH_1:
      "Thanks! We'll take a look and get back to you within 2 working days via your new address ({username}).",
    LOGIN_ACCOUNT_RECOVERY_SUCCESS_PARAGRAPH_2:
      "N.B.: If your account is deactivated at the moment, we'll reactivate it for you right away.",
    LOGIN_ACCOUNT_RECOVERY_SUCCESS_PARAGRAPH_3: 'You may close this page now.',
    LOGIN_ACCOUNT_RECOVERY_SUCCESS_TITLE: 'Success!',
    LOGIN_ACCOUNT_RECOVERY_TITLE: "Don't have access to that e-mail address?",
    LOGIN_ACCOUNT_RECOVERY_WRONG_CONFIRMATION_CODE:
      "That doesn't seem to be the right code. Please try again.",
    LOGIN_ACCOUNT_SEARCH_CRITERIA_DESCRIPTION:
      "Don't worry! We can verify your identity so you can change your login e-mail address.",
    LOGIN_ACCOUNT_SEARCH_CRITERIA_DESCRIPTION_2:
      "Let's start with details that you added to your XING profile.",
    LOGIN_ADMIN_BULK_PROCESS_FULL_EMAIL:
      "‪Hi ‪{first_name}‬,\n\nYour XING account was temporarily unprotected, and we suspect that your login details (e-mail and password) have been disclosed to third parties.\n\nHackers often engage in what's known as 'credential stuffing', meaning they use an e-mail address and password combination on multiple websites (including XING) to try and gain access to accounts on those sites.\n\nIn this instance it seems likely that such an attempt worked with your XING account. We've already blocked access to your account, but it's possible that information has been added to or removed from your profile in the meantime.\n\nTo find out whether your e-mail address was leaked, you can enter it in https://haveibeenpwned.com/ to see whether it appeared in a list of known stolen account details.\n\nYour XING profile has been reactivated. You can create a new password here:\nhttps://login.xing.com/recovery\n\nPlease make sure you choose a new, secure password.\n\nInformation on choosing a secure password is available here: https://faq.xing.com/en/security/secure-password\n\nIf you have any questions, please get in touch with us: \nhttps://www.xing.com/support/contact/security/report_security_issue‬",
    LOGIN_BLACKLISTED_P2_MAILTO_TARGET: 'mailto:en-quality@xing.com',
    LOGIN_BLACKLISTED_P2_MAILTO_TEXT: 'Contact support',
    LOGIN_BLACKLISTED_P3_HELPSECTION_LINK_TARGET:
      'https://faq.xing.com/en/security/blocked-xing-profile',
    LOGIN_BLACKLISTED_P3_HELPSECTION_LINK_TEXT: 'help section',
    LOGIN_BLACKLISTED_PARAGRAPH_1:
      'Your XING profile has been blocked, either for security reasons or because our General Terms and Conditions were violated.',
    LOGIN_BLACKLISTED_PARAGRAPH_2:
      'To get your profile reactivated, please send an e-mail to the following address from the e-mail address or mobile number you just used to log in to XING:',
    LOGIN_BLACKLISTED_PARAGRAPH_3:
      'The reasons why your profile may have been blocked are available in our {helpCenterLink}.',
    LOGIN_BLACKLISTED_SALUTATION: 'Dear XING member,',
    LOGIN_CREATE_REQUEST_ERROR:
      'Sorry, something  went wrong. Please try again.',
    LOGIN_EMAIL_CHANGE_INFO:
      'Your e-mail address was successfully confirmed. Please log in with your username / e-mail address and password.',
    LOGIN_ENABLE_TWO_FA_SMS_TEXT:
      'Use {code} as your code to turn on two-factor authentication for XING.',
    LOGIN_FLIP_LINK_BACK: 'Log in',
    LOGIN_FORGOT_PASSWORD: 'Forgotten your password?',
    LOGIN_FRONTEND_META_DESCRIPTION:
      'Find new jobs, interesting contacts and inspiring news on XING.',
    LOGIN_FRONTEND_META_TITLE: 'Log in to XING',
    LOGIN_GENERIC_REQUEST_LIMIT_REACHED:
      "Unfortunately you've tried to reset your password too many times. Please wait at least 12 hours before trying again.",
    LOGIN_HEADLINE: 'Welcome back!',
    LOGIN_INQUIRY_NO_DATA_REASON:
      "You're not currently logged in to XING in a web browser.",
    LOGIN_INQUIRY_SECTION_2FA_TITLE: 'Two-factor authentication',
    LOGIN_INQUIRY_SECTION_ACTIVE_SESSION_TITLE:
      'Where are you logged in to XING?',
    LOGIN_INQUIRY_TBODY_2FA_AUTHENTICATOR:
      'Activated (with authentication app)',
    LOGIN_INQUIRY_TBODY_2FA_NONE: 'Not activated',
    LOGIN_INQUIRY_TBODY_2FA_SMS: 'Activated (with SMS)',
    LOGIN_INQUIRY_THEAD_2FA_STATUS: 'Status',
    LOGIN_INQUIRY_THEAD_BROWSER: 'Browser',
    LOGIN_INQUIRY_THEAD_ISP: 'ISP',
    LOGIN_INQUIRY_THEAD_LAST_USED: 'Last used',
    LOGIN_INQUIRY_THEAD_LOCATION: 'Location',
    LOGIN_INQUIRY_THEAD_LOGIN_DATE: 'Login date',
    LOGIN_INQUIRY_TITLE: 'Login sessions',
    LOGIN_INTERSTITIAL_SKIP_BUTTON: 'Go to homepage',
    LOGIN_INVALID_PASSWORD:
      'Your username or password is incorrect. Please try again.',
    LOGIN_KNOWN_USER_FEMALE: '{firstName}',
    LOGIN_KNOWN_USER_LOGIN_BUTTON: 'Log in now',
    LOGIN_KNOWN_USER_MALE: '{firstName}',
    LOGIN_KNOWN_USER_TEXT: 'Nice to see you again,',
    LOGIN_LOGOUT_COMEBACK:
      "You're now logged out. Want to drop in again? {loginLink}",
    LOGIN_LOGOUT_COMEBACK_CTA: 'Log in again',
    LOGIN_LOGOUT_COMEBACK_MESSAGE:
      "You're now logged out. Want to drop in again?",
    LOGIN_LOGOUT_HEADLINE: "You're now logged out.",
    LOGIN_LOGOUT_HEADLINE_DAY: 'Have a nice day!',
    LOGIN_LOGOUT_HEADLINE_MORNING: 'Have a good one!',
    LOGIN_LOGOUT_HEADLINE_NIGHT: 'Enjoy your evening!',
    LOGIN_LOGOUT_LOGIN_LINK_TEXT: 'Log in',
    LOGIN_LOGOUT_META_TITLE: "You're now logged out | XING",
    LOGIN_LOGOUT_MOBILE_AD_BODY:
      "The XING app shows you what's new in your network, including job moves, birthdays and posts by your contacts.",
    LOGIN_LOGOUT_MOBILE_AD_HEADLINE: "Be first to find out what's new",
    LOGIN_LOGOUT_SURVEY_ANSWER_NEVER_FORGET: 'I never forget my login details.',
    LOGIN_LOGOUT_SURVEY_ANSWER_NO_TRUST: "I don't trust XING.",
    LOGIN_LOGOUT_SURVEY_ANSWER_NOT_MY_DEVICE:
      "I was using someone else's device.",
    LOGIN_LOGOUT_SURVEY_ERROR_REQUIRED: 'Please tell us why you logged out.',
    LOGIN_LOGOUT_SURVEY_FREE_TEXT_LABEL:
      'Other: Please enter your reason here (max. 160 chars.)',
    LOGIN_LOGOUT_SURVEY_HEADLINE: 'Tell us why you just logged out.',
    LOGIN_LOGOUT_SURVEY_SUBMIT_LABEL: 'Submit answer',
    LOGIN_LOGOUT_SURVEY_SUCCESS_MESSAGE: 'Thanks for your answer!',
    LOGIN_NAVIGATION_LOGIN_ERROR_INVALID:
      "Sorry, we didn't recognise your login details just now. Could you please enter them again?",
    LOGIN_NEW_EMAIL_LABEL: 'E-mail',
    LOGIN_NEW_PASSWORD_LABEL: 'Password',
    LOGIN_NEW_PROBLEMS_TEXT: 'Having problems logging in?',
    LOGIN_NEW_REGISTER_TEXT: 'Not joined XING yet? Register now free of charge',
    LOGIN_NEW_REMEMBER_ME_TEXT: 'Remember me',
    LOGIN_NEW_SUBMIT_TEXT: 'Log in',
    LOGIN_NEW_TITLE: 'Welcome back!',
    LOGIN_NOSCRIPT_LINK_TARGET: 'https://faq.xing.com/de/node/67945',
    LOGIN_NOSCRIPT_LINK_TEXT: 'How to enable JavaScript',
    LOGIN_NOSCRIPT_PARAGRAPH:
      'You need to have JavaScript enabled to see all of the available content.',
    LOGIN_NOSCRIPT_TITLE: 'Please enable JavaScript',
    LOGIN_NOT_ME: 'Not you? Switch user',
    LOGIN_OAUTH_INFO_PARAGRAPH:
      'Please sign in with your XING login details to grant {application} access to your XING data.',
    LOGIN_ONE_TIME_LINK_EXPLAINER:
      "How it works: We'll e-mail you a single-use login link.",
    LOGIN_ONE_TIME_LINK_INVALID:
      'Unfortunately this link is no longer valid. Please log in with your username and password.',
    LOGIN_ONE_TIME_LINK_LINK: 'Request login link',
    LOGIN_ONE_TIME_LINK_OR: 'or',
    LOGIN_ONE_TIME_LINK_SUCCESS_FOOTNOTE:
      'Please note: For security reasons, your link is only valid for 30 minutes and can only be used once.',
    LOGIN_ONE_TIME_LINK_SUCCESS_HEADLINE: 'Almost there:',
    LOGIN_ONE_TIME_LINK_SUCCESS_PARAGRAPH:
      "Just click on the link and you'll be logged in to XING.",
    LOGIN_ONE_TIME_LINK_SUCCESS_PARAGRAPH_WITH_EMAIL:
      'We sent your login link to {email}.',
    LOGIN_ONE_TIME_LINK_TEASER: 'Log in securely - without a password',
    LOGIN_ONE_TIME_LOGIN_REQUEST_LIMIT_REACHED:
      'For security reasons, you can only request a link once per minute. Please enter your login details or wait at least one minute before requesting a link again.',
    LOGIN_ONLYFY_HEADLINE:
      'Connect your account by logging in to your XING account',
    LOGIN_ONLYFY_PLACEHOLDER_EMAIL: 'Your XING e-mail address',
    LOGIN_ONLYFY_PLACEHOLDER_PASSWORD: 'Your XING password',
    LOGIN_ONLYFY_REGISTRATION_LINK:
      'Not joined XING yet? Register now free of charge',
    LOGIN_PASSWORD_IS_RESET:
      'Your new password is active so you can use it to log in.',
    LOGIN_PASSWORD_PLACEHOLDER: 'Please enter your password',
    LOGIN_PASSWORD_RECOVERY_CONFIRM_BACK:
      'Correct e-mail address / mobile number',
    LOGIN_PASSWORD_RECOVERY_CONFIRM_DESCRIPTION:
      'Please enter the code we just sent to {username}.',
    LOGIN_PASSWORD_RECOVERY_CONFIRM_SUBMIT: 'Next',
    LOGIN_PASSWORD_RECOVERY_CONFIRM_TITLE: 'Enter verification code',
    LOGIN_PASSWORD_RESET_BUTTON_CONTINUE: 'Enter new password',
    LOGIN_PASSWORD_RESET_LABEL_NEW: 'Enter new password',
    LOGIN_PASSWORD_RESET_SUBLINE:
      'Tip: Choose a secure password by making sure it contains at least eight characters, including lower- and upper-case letters, digits, and special characters (such as *, %, §, ?).',
    LOGIN_PASSWORD_RESET_TITLE: 'Enter new password',
    LOGIN_PASSWORD_STRENGTH_HIGH: 'Looking good!',
    LOGIN_PASSWORD_STRENGTH_LOW: "It's a start...",
    LOGIN_PASSWORD_STRENGTH_MIDDLE: 'Getting there...',
    LOGIN_POST_LOGIN_SCREEN_ADVERTISE_TWOFA_CTA_TEXT: 'Turn on',
    LOGIN_POST_LOGIN_SCREEN_ADVERTISE_TWOFA_PARAGRAPH:
      "You can make your XING login even more secure with an additional verification step. Every time you log in to XING, you'll receive a one-off access code you then need to enter to confirm your identity.",
    LOGIN_POST_LOGIN_SCREEN_ADVERTISE_TWOFA_SKIP_TEXT: 'Skip',
    LOGIN_POST_LOGIN_SCREEN_ADVERTISE_TWOFA_SUBTITLE:
      'Enhance your login security',
    LOGIN_POST_LOGIN_SCREEN_ADVERTISE_TWOFA_TITLE:
      'Turn on two-factor authentication',
    LOGIN_POST_LOGIN_SCREEN_CHANGE_PASSWORD_CTA_TEXT: 'Change password',
    LOGIN_POST_LOGIN_SCREEN_CHANGE_PASSWORD_PARAGRAPH:
      'Someone may have tried to intercept your login details.',
    LOGIN_POST_LOGIN_SCREEN_CHANGE_PASSWORD_SUBTITLE:
      'Please change your password immediately.',
    LOGIN_POST_LOGIN_SCREEN_CHANGE_PASSWORD_TITLE:
      'Please change your XING password',
    LOGIN_POST_LOGIN_SCREEN_EMAIL_BOUNCED_CTA_TEXT: 'Update now',
    LOGIN_POST_LOGIN_SCREEN_EMAIL_BOUNCED_PARAGRAPH:
      '{email} is the e-mail address currently in use on XING, but our messages keep coming back. Could you please check and update it if necessary?',
    LOGIN_POST_LOGIN_SCREEN_EMAIL_BOUNCED_SKIP_TEXT: 'Still valid',
    LOGIN_POST_LOGIN_SCREEN_EMAIL_BOUNCED_TITLE:
      'Please check your e-mail address',
    LOGIN_POST_LOGIN_SCREEN_PASSWORD_IN_DANGER_PARAGRAPH:
      'We noticed that your XING account is no longer secure.',
    LOGIN_POST_LOGIN_SCREEN_PASSWORD_MORE_INFO_LINK_TARGET:
      'https://faq.xing.com/en/security/xing-protects-your-user-account-against-identity-theft',
    LOGIN_POST_LOGIN_SCREEN_PASSWORD_MORE_INFO_LINK_TEXT: 'More info',
    LOGIN_POST_LOGIN_SCREEN_PASSWORD_TOO_OLD_PARAGRAPH:
      'Unfortunately, your password is outdated and no longer secure.',
    LOGIN_REACTIVATION_BUTTON_LABEL: 'Reactivate profile',
    LOGIN_REACTIVATION_LOG_OUT:
      'Not interested in reactivating your profile? <a>Log out</a>',
    LOGIN_REACTIVATION_PARAGRAPH:
      'You can reactivate it now if you prefer. That way, people will be able to find you again on XING.',
    LOGIN_REACTIVATION_SUB_TITLE:
      'Your XING profile has been deactivated until {date}.',
    LOGIN_REACTIVATION_TITLE: 'Welcome back to XING!',
    LOGIN_RECOVERY_BACK: 'Log in',
    LOGIN_RECOVERY_CHANGE_EMAIL: 'Next',
    LOGIN_RECOVERY_CHANGE_EMAIL_ARIA_LABEL: 'Continue to confirmation code',
    LOGIN_RECOVERY_CONTINUE: 'Next',
    LOGIN_RECOVERY_CONTINUE_ARIA_LABEL: 'Continue to verify identity',
    LOGIN_RECOVERY_DATE_PLACEHOLDER: 'yyyy-mm-dd',
    LOGIN_RECOVERY_DESCRIPTION:
      'No problem: Please enter the e-mail address you use to log in to XING.',
    LOGIN_RECOVERY_FORGOT_CREDENTIALS: 'Forgotten your e-mail address?',
    LOGIN_RECOVERY_FORGOT_CREDENTIALS_CONTINUE: 'Next',
    LOGIN_RECOVERY_FORGOT_CREDENTIALS_CONTINUE_ARIA_LABEL:
      'Continue to verify identity',
    LOGIN_RECOVERY_FORGOT_OR_NO_ACCESS_CREDENTIALS: 'E-mail not working?',
    LOGIN_RECOVERY_FORGOT_PASSWORD_CONTINUE: 'Next',
    LOGIN_RECOVERY_FORGOT_PASSWORD_CONTINUE_ARIA_LABEL:
      'Continue to confirmation code',
    LOGIN_RECOVERY_INPUT_LABEL: 'E-mail',
    LOGIN_RECOVERY_INVALID_CODE:
      'Sorry, but the code to reset your password has expired: Please request a new one.',
    LOGIN_RECOVERY_INVALID_LINK:
      'Sorry, but the link to reset your password has expired: Please request a new one.',
    LOGIN_RECOVERY_OTHER_PROBLEMS: 'Other problems logging in?',
    LOGIN_RECOVERY_OTHER_PROBLEMS_LINK_TEXT: 'Contact us',
    LOGIN_RECOVERY_SUCESSFUL_RESET_TITLE:
      'Excellent! You now have a new password.',
    LOGIN_RECOVERY_TFA_CTA: 'Turn off two-factor authentication',
    LOGIN_RECOVERY_TFA_DESCRIPTION_1:
      'When you turned on two-factor authentication you received a code that lets you turn it off again or log in. ',
    LOGIN_RECOVERY_TFA_DESCRIPTION_2: 'Please contact us.',
    LOGIN_RECOVERY_TFA_EMAIL_BODY:
      "Please turn off two-factor authentication for my account.\n\nMy account: [Please enter the link to your profile here.]\n\nI've attached a photo of my ID card, driving licence or health insurance card (front and back) as proof of my identity.\n[Please attach a photo of your ID card, driving licence or health insurance card.] ",
    LOGIN_RECOVERY_TFA_EMAIL_SUBJECT: 'Two-factor authentication problems',
    LOGIN_RECOVERY_TFA_HEADER: 'Two-factor authentication problems',
    LOGIN_RECOVERY_TFA_SUBHEADER_1:
      "Have you turned on two-factor authentication but can't receive login codes right now?",
    LOGIN_RECOVERY_TFA_SUBHEADER_2: 'Forgotten your backup code?',
    LOGIN_RECOVERY_TITLE: 'Forgotten your password?',
    LOGIN_RECOVERY_UPLOAD: 'Next',
    LOGIN_RECOVERY_UPLOAD_ARIA_LABEL: 'Continue to change e-mail',
    LOGIN_REGISTRATION_CONTINUE: 'Next',
    LOGIN_REGISTRATION_CONTINUE_ARIA_LABEL:
      'Continue to register and confirm e-mail',
    LOGIN_REGISTRATION_HEADLINE:
      "Sign up now – it's free and only takes 2 minutes!",
    LOGIN_REGISTRATION_SIGNIN_HEADLINE: 'Log in',
    LOGIN_REGISTRATION_SUBHEADLINE: 'Already a XING member? {signin}',
    LOGIN_RESEND_CODE_SEND: 'Not received your code? {link}',
    LOGIN_RESEND_CODE_SEND_LINK: 'Resend',
    LOGIN_RESEND_CODE_SUCCESS:
      "We've sent you a new code. The old code is no longer valid.",
    LOGIN_RESEND_CODE_WAIT:
      'Please wait {countdown} seconds for the code to arrive.',
    LOGIN_RESEND_ERROR: "Sorry, that didn't work. Please try again.",
    LOGIN_RESEND_LINK_SEND: 'Not received a link? {link}',
    LOGIN_RESEND_LINK_SEND_LINK: 'Resend now',
    LOGIN_RESEND_LINK_SUCCESS:
      "We've sent you a new link as the old one has expired.",
    LOGIN_RESEND_LINK_WAIT: 'Your link should arrive in {countdown} seconds.',
    LOGIN_SEPARATOR: 'or',
    LOGIN_SETTINGS_ERROR_ACTIVE_PASSWORD_INCORRECT:
      "You now have {count} incorrect password attempts. After 3 incorrect attempts, we'll deactivate all of your active sessions to protect your account.",
    LOGIN_SETTINGS_ERROR_ACTIVE_PASSWORD_MISSING:
      'Please enter your new password.',
    LOGIN_SETTINGS_ERROR_NEW_PASSWORD_EQ_EMAIL:
      "For your own security, please choose a password that's difficult to guess (e.g. not your e-mail address).",
    LOGIN_SETTINGS_ERROR_NEW_PASSWORD_EQ_FIRST_NAME:
      "For your own security, please choose a password that's difficult to guess (e.g. not your first name).",
    LOGIN_SETTINGS_ERROR_NEW_PASSWORD_EQ_LAST_NAME:
      "For your own security, please choose a password that's difficult to guess (e.g. not your last name).",
    LOGIN_SETTINGS_ERROR_NEW_PASSWORD_EQ_USER_NAME:
      "For your own security, please choose a password that's difficult to guess (e.g. not your username).",
    LOGIN_SETTINGS_ERROR_NEW_PASSWORD_FOUND_LEAKED:
      "Your new password and your e-mail address are listed in a database for leaked login details. We always perform such a check when users update their password. Please set a different password you haven't used on any other websites.",
    LOGIN_SETTINGS_ERROR_NEW_PASSWORD_MISSING:
      'Please enter your new password.',
    LOGIN_SETTINGS_ERROR_NEW_PASSWORD_TOO_LONG:
      'Please enter a password containing up to 1,024 characters.',
    LOGIN_SETTINGS_ERROR_NEW_PASSWORD_TOO_SHORT:
      'Please enter a password containing at least 8 characters.',
    LOGIN_SETTINGS_ERROR_NEW_PASSWORD_USED_BEFORE:
      "For your own protection, you cannot use this password: You've already used this as a password.",
    LOGIN_SETTINGS_ERROR_PASSWORD_TOKEN_INVALID_PASSWORD:
      "Unfortunately your password didn't work. Please try again.",
    LOGIN_SETTINGS_ERROR_PASSWORD_TOKEN_PASSWORD_MISSING:
      'Please enter your XING password.',
    LOGIN_SETTINGS_ERROR_TFA_ACTIVE_PHONE_UNDEFINED:
      'Please add a mobile number first. Then use that number to set up two-factor authentication.',
    LOGIN_SETTINGS_ERROR_TFA_ALREADY_ACTIVE:
      'Good news – two-factor authentication is already turned on.',
    LOGIN_SETTINGS_ERROR_TFA_ALREADY_INACTIVE:
      'Two-factor authentication is already turned off.',
    LOGIN_SETTINGS_ERROR_TFA_ATTEMPT_LIMIT_REACHED:
      "You've tried this too many times now. Please try again later.",
    LOGIN_SETTINGS_ERROR_TFA_INVALID_CODE:
      "Sorry, that code didn't work. Please check it again.",
    LOGIN_SETTINGS_ERROR_TFA_INVALID_TOKEN:
      'Unfortunately, this entry has timed out. Could you please enter your password again?',
    LOGIN_SIGNUP_HEADLINE: 'Register now free of charge',
    LOGIN_SUBHEADLINE: 'Not joined XING yet? {signup}',
    LOGIN_TFA_BACKUP_CODE_DESCRIPTION:
      'Please note that two-factor authentication will be turned off if you do this. You can turn it on again in your settings.',
    LOGIN_TFA_BACKUP_CODE_EXPLANATION_LINK: "What's my backup code?",
    LOGIN_TFA_BACKUP_CODE_FORM_LABEL: 'Current backup code',
    LOGIN_TFA_BACKUP_CODE_FORM_LABEL_WITH_PREFIX:
      'Your backup code (starts with {prefix})',
    LOGIN_TFA_BACKUP_CODE_GO_BACK_LINK: 'Back',
    LOGIN_TFA_BACKUP_CODE_LINK: " Can't get to the code?",
    LOGIN_TFA_BACKUP_CODE_MODAL_CONTACT_LINK: 'please get in touch with us',
    LOGIN_TFA_BACKUP_CODE_MODAL_CONTACT_TEXT: "If this isn't possible, {link}",
    LOGIN_TFA_BACKUP_CODE_MODAL_DESCRIPTION:
      'You received a backup code when you turned on two-factor authentication. Please enter your backup code here to log in.',
    LOGIN_TFA_BACKUP_CODE_SUBMIT_TEXT: 'Log in',
    LOGIN_TFA_BACKUP_CODE_TITLE: 'Log in with backup code',
    LOGIN_TWO_FA_SMS_TEXT: 'Use {code} as your code to log in to XING.',
    LOGIN_TWOFA_AUTHENTICATOR_BUTTON_LABEL: 'Verify',
    LOGIN_TWOFA_AUTHENTICATOR_DESCRIPTION:
      'Please enter the access code displayed in your authenticator app.',
    LOGIN_TWOFA_AUTHENTICATOR_LABEL: 'Access code',
    LOGIN_TWOFA_AUTHENTICATOR_TITLE: 'Enter access code',
    LOGIN_TWOFA_ERROR_INVALID_CODE:
      "Sorry, that code didn't work. Please check it again.",
    LOGIN_TWOFA_HINT_AUTHENTICATOR:
      'Your access code is available in your authentication app.',
    LOGIN_TWOFA_HINT_SMS:
      'We sent you an SMS containing your code to the number ending in {phone}',
    LOGIN_TWOFA_SMS_BUTTON_LABEL: 'Verify',
    LOGIN_TWOFA_SMS_DESCRIPTION:
      'Please enter the one-off access code sent via SMS to the number {anonymizedPhone}.',
    LOGIN_TWOFA_SMS_LABEL: 'Unique access code',
    LOGIN_TWOFA_SMS_RESEND_SMS_SEND: 'Resend code',
    LOGIN_TWOFA_SMS_RESEND_SMS_WAIT:
      'Please wait {countdown} more seconds for the SMS to arrive.',
    LOGIN_TWOFA_SMS_TITLE: 'Enter access code',
    LOGIN_TWOFA_WHITELIST_BROWSER: "Don't ask again on this computer",
    LOGINHTML_EXPL_ENTER:
      'Please enter your login details here. <strong>Cookies must be activated to log in.</strong>',
    LOGINHTML_EXPL_FORGOT:
      '<a href="https://login.xing.com/recovery">Forgotten your password?</a>',
    LOGINHTML_EXPL_REG:
      'Not joined XING yet?<br><a href="/signup">Sign up</a> for free!',
    LOGINHTML_HEADLINE: 'Log in',
    LOGINHTML_LOGINBUTTON: 'Log in',
    LOGINHTML_SUBHEADLINE: 'Already a XING member? Then just log in below.',
    MALT_FOOTER_COPYRIGHT_API: '© {siteoperator}  | All rights reserved',
    MALT_WELCOME_LOGIN_SETTINGS_LAND_DROPDOWN_AT: 'Austria',
    MALT_WELCOME_LOGIN_SETTINGS_LAND_DROPDOWN_CH: 'Switzerland',
    MALT_WELCOME_LOGIN_SETTINGS_LAND_DROPDOWN_DE: 'Germany',
    MYXS_HEADLINE: 'Manage your XING sessions',
    NOTE_REGISTER_USER_NAME:
      'Please note: Your username must be at least three characters long and may not contain the symbols @ and : or any spaces.',
    NOTIFICATION_CENTER_LINK: 'Notifications',
    PASSWORD_RESET_REQUEST_LIMIT_REACHED:
      'Sorry, you tried to renew your password too many times. Please wait at least 12 hours before trying it again.',
    PASSWORD_RESET_UNKNOWN_CREDENTIALS:
      "Sorry, that account doesn't seem to exist.",
    PASSWORDHTML_EXPLANATION:
      'Enter the e-mail address you use to receive XING notifications here and we will send you a link so you can change password.<br> \n<a href="/help/help-and-faq-2/general-stuff-55/registration-and-login-808" target="_blank">Help with logging in</a>',
    PASSWORDHTML_HEADLINE: 'Problems with your password',
    PASSWORDHTML_NEW_PASSWORD_HEAD: 'Create new password',
    PASSWORDHTML_OR: 'or',
    PASSWORDHTML_PASSWORD_SENT:
      'Your password was changed. Now you can use your new password to log in.',
    PASSWORDHTML_REQUEST_SENT:
      "Please check your inbox as we've sent an e-mail to the e-mail address you linked to your XING profile. When you click on the link in the e-mail, you'll be automatically forwarded to a page explaining how to create your new password. \n<br><br>\n<strong>Haven't received an e-mail yet?</strong> Please check your spam folder and make sure our e-mail hasn't ended up there. If don't receive our e-mail within 2 hours, please  <a href=\"/app/user?op=support\">contact us</a>.",
    PASSWORTHTML_LIMIT_REACHED:
      'Unfortunately we couldn\'t send you the information on how to create a new password. Please <a href="/app/user?op=support">get in touch with us</a>.',
    PASSWORTHTML_LIMIT_REACHED_GENERIC:
      'Unfortunately we couldn\'t send you the information on how to create a new password. Please <a href="{url_prefix}/app/user?op=support">get in touch with us</a>.',
    PASSWORTHTML_USER_UNKNOWN:
      "Unfortunately your username and/or password is/are incorrect. Please enter your login information again.<br><br> \n<strong>Tip:</strong> If you're not sure which e-mail address you used to register on XING, just check which e-mail address XING uses to send you messages such as newsletters.",
    PASSWORTHTML_USER_UNKNOWN_SHORT:
      "Sorry, we didn't recognise your login details. Please check them again.",
    PASSWORTHTML_USER_UNKNOWN_WITH_PHONE:
      "Sorry, we didn't recognise that. Please enter your e-mail address or mobile number again.<br><br> \n<strong>Tip:</strong> If you're not sure which e-mail address you used to register on XING, just check which e-mail address XING uses to send you messages such as newsletters.",
    PM_UNSAFE_PW_CHANGE_NOW: 'Change your password now!',
    PM_UNSAFE_PW_HINT_4:
      'Your password should contain at least ten characters, a mixture of upper and lower case, numbers and \nspecial characters.',
    PM_UNSAFE_PW_HOW_TO_CHANGE:
      'How do I create the most secure password possible?',
    PROFILE_EMAILCHANGE_HEADER: 'Please confirm your e-mail address',
    PROFILE_EMAILS_CONFIRMATION_BOUNCE:
      "We were unable to confirm '{-email}', your e-mail address for notifications, as the confirmation message was returned to sender. Please recheck the e-mail address you entered, and request a new notification e-mail be sent.",
    PROFILE_EMAILS_CONFIRMATION_INFO:
      "We sent an e-mail to your address: '{-email}'. Please log in to your account and click on the confirmation link in the e-mail. After you've confirmed your address, it will be activated, and you'll be able to log in to the site again. Did you enter the wrong e-mail address? You can make corrections below.",
    PROFILE_EMAILS_CONFIRMATION_INFO2:
      'Your active notification address has not yet been confirmed. \nAfter you’ve confirmed this address, it will be activated and you’ll be able to log in to XING again. \nIf you did not receive the message, or have made a mistake while entering in the data, you can request a new confirmation e-mail be sent to you.',
    PROFILE1HTML_NEW_CONF: 'New password confirmation',
    PROFILE1HTML_NEW_PASSWORD: 'New password',
    REMINDER_UNDESIRED_USER:
      "<p>Dear member,</p><br/><br />\n\n<p>We’d like to inform you that your profile has been temporarily deactivated. This may be due one of the following occurrences:</p>\n\n<p>…Another person has had access to your profile</p>\n<p>…You have created a fake or 'joke' profile</p>\n<p>…You have entered a nom de plume or pseudonym into the name field on your profile</p>\n<p>…You have created the same profile twice</p>\n<p>…You have created an anonymous profile</p>\n<p>…You have used the XING platform for multilevel marketing purposes</p>\n<p>…You have entered a job title on your business card that's out of date and/or entered a business e-mail address that's invalid</p>\n<p>…You have been using your profile to send spam</p>\n\n<p>There are numerous other reasons why your profile might have temporarily deactivated.\nWe have taken this step in the interest of our members – including in your interest - to ensure the serious nature and security of our platform.</p> \n<p>We can imagine that the deactivation of your profile is inconvenient for you; please be patient, however. Please keep in mind that in deactivating your profile, we’re also doing our best to insure your profile is not further misused.</p>\n\n<p>If you have questions or wish to correct any errors you believe have occurred, please send an e-mail to our team:\nen-quality@xing.com</p> \n\n<p>We’ll do our best to look into the situation as quickly as possible and reactivate your profile soon after that.</p>",
    SETTINGS_MYXS_CURRENT_SESSION_HEADLINE: 'Current session',
    SETTINGS_MYXS_HEADLINE: 'Manage your XING sessions',
    SETTINGS_MYXS_INFOTEXT:
      'See a list of sessions showing you the devices you logged in with as well as when and where you logged in. Your active session is highlighted. You can terminate a session if it looks unfamiliar, suspicious, or obsolete.\n',
    SETTINGS_MYXS_TERMINATE_LINK_TEXT: 'Terminate',
    SETTINGS_MYXS_TEXT_BROWSER: 'Browser:',
    SETTINGS_MYXS_TEXT_LAST_ACCESS: 'Last access:',
    SETTINGS_MYXS_TEXT_LOGIN_DATE: 'Login on:',
    SETTINGS_MYXS_TEXT_LOGIN_LOCATION: 'Login from:',
    SETTINGS_MYXS_TEXT_LOGIN_LOCATION_NEAR: 'Near {city_name}',
    SETTINGS_MYXS_TEXT_PROVIDER: 'Provider:',
    SYSM_TFA_DISABLED_EMAIL_HEADER:
      'Your two-factor authentication has been deactivated.',
    SYSM_TFA_DISABLED_EMAIL_LIST_1:
      'You deactivated two-factor authentication in your XING settings.',
    SYSM_TFA_DISABLED_EMAIL_LIST_2: 'You used your backup code.',
    SYSM_TFA_DISABLED_EMAIL_LIST_3:
      'You asked us to deactivate two-factor authentication.',
    SYSM_TFA_DISABLED_EMAIL_LIST_4:
      'You asked us to change your authentication details.',
    SYSM_TFA_DISABLED_EMAIL_PARAGRAPH_1:
      'This may be due to one of the following reasons:',
    SYSM_TFA_DISABLED_EMAIL_PARAGRAPH_2:
      'If none of the above applies to you, please get in touch with us.\nBy the way: You can reactivate two-factor authentication at any time in your XING settings.',
    SYSM_TFA_DISABLED_EMAIL_PREHEADER: 'You can reactivate it at any time.',
    SYSM_TFA_DISABLED_EMAIL_SUBJECT:
      'Your XING two-factor authentication has been deactivated.',
    SYSM_TFA_EMAIL_CONTACT_LINK: 'Contact us',
    SYSM_TFA_ENABLED_EMAIL_HEADER:
      'Your two-factor authentication has been activated.',
    SYSM_TFA_ENABLED_EMAIL_PARAGRAPH_1:
      'That way, your data is more secure than ever before.',
    SYSM_TFA_ENABLED_EMAIL_PARAGRAPH_2:
      "If you didn't activate two-factor authentication, please get in touch with us:",
    SYSM_TFA_ENABLED_EMAIL_PARAGRAPH_3:
      "If you didn't activate two-factor authentication, ",
    SYSM_TFA_ENABLED_EMAIL_PARAGRAPH_4: 'Please get in touch with us:',
    SYSM_TFA_ENABLED_EMAIL_PREHEADER:
      'That way, your data is more secure than ever before.',
    SYSM_TFA_ENABLED_EMAIL_SUBJECT:
      'Your XING two-factor authentication has been activated.',
    TFA_DISABLED_NOTIFICATION_SMS:
      'Two-factor authentication has been deactivated for your XING account.',
    TFA_ENABLED_NOTIFICATION_SMS:
      'Two-factor authentication has been activated for your XING account.',
    TSV_DISABLE: 'Disable two-step verification',
    TSV_DISABLE_VERIFY_WITH_PASSWORD:
      'Please enter your password to disable two-step verification.',
    TSV_ENABLE: 'Enable two-step verification',
    TSV_FAILED:
      "Sorry, your verification code is invalid. Maybe there's a typo?",
    TSV_HEADLINE_TWO_STEP_VERIFICATION: 'Two-step verification',
    TSV_HEADLINE_VERIFICATION_CODE: 'Verification code',
    TSV_IS_DISABLED: 'Disabled',
    TSV_IS_ENABLED: 'Enabled',
    TSV_SCAN_QR_AND_VERIFY_CODE:
      'Please scan the QR code with your authenticator app. Then confirm it with the generated verification code.\n',
    TSV_VERIFICATION_CODE: 'Verification code',
    UVP_APP_MESSAGE_INVALID_TOKEN:
      'Sorry, but the link to reset your password is no longer valid.',
    UVP_APP_MESSAGE_PW_MISMATCH: "The passwords don't match.",
    UVP_CONFIRM_EMAIL_INVALID_LINK:
      'Unfortunately this link is no longer valid. Please start again.',
    UVP_EMAIL_ACCESS_CONFIRM_LABEL: 'Confirm e-mail address:',
    UVP_EMAIL_ACCESS_DESCRIPTION:
      'Just enter this e-mail address here.<br>\n<strong>Gmail users:</strong> Please enter the domain "gmail.com" or "googlemail.com" exactly as you entered it during registration.',
    UVP_EMAIL_ACCESS_HEADLINE: "Remember your e-mail address but can't log in?",
    UVP_EMAIL_ACCESS_LABEL: 'E-mail:',
    UVP_EMAIL_CONFIRM_MESSAGE_HEADLINE: 'Please check your messages.',
    UVP_EMAIL_CONFIRM_MESSAGE_TEXT:
      "We've sent an e-mail to your new preferred e-mail address. Just click on the link in that e-mail to submit your change of e-mail address request to our Support team.<br><br>\n<strong>Haven't received an e-mail yet?</strong> Please check your spam folder and make sure our e-mail hasn't ended up there. If don't receive our e-mail within 2 hours, please <a href=\"{support_link}\">contact us</a>.",
    UVP_EMAIL_FORM_LABEL: 'E-mail:',
    UVP_EMAIL_OR_PHONE_ACCESS_DESCRIPTION:
      '<strong>Did you register on XING with your e-mail address?</strong> If so, please enter it here.<br>\n(Tip: The e-mail address you used to register on XING is the one via which you receive XING notifications.)<br><br>\n<strong>Did you register on XING with your mobile number instead?</strong> If so, please enter it here.<br>\n(Tip: The mobile number you used to register on XING is the one via which you received your XING activation code SMS.)',
    UVP_EMAIL_OR_PHONE_ACCESS_HEADLINE:
      "Remember your e-mail address/mobile number but can't log in?",
    UVP_EMAIL_OR_PHONE_TAB:
      "Can't log in to your e-mail or remember your mobile phone number?",
    UVP_EMAIL_PHONE_FORM_LABEL: 'E-mail / mobile number',
    UVP_EMAIL_PROCESS_APPROVED_SUBJECT:
      'Your XING profile: Your new e-mail address has been confirmed',
    UVP_EMAIL_PROCESS_APPROVED_TEXT:
      "We've now updated your login details for you.\n\nGo ahead and log in with your new e-mail address:\n{login_url}",
    UVP_EMAIL_PROCESS_CONFIRM_MAIL_SUBJECT:
      'Please confirm your new e-mail address.',
    UVP_EMAIL_PROCESS_CONFIRM_MAIL_TEXT:
      "We've received your change of e-mail address request.<br>\n<br>\nIf someone else has sent this request on your behalf or if you have access to your old e-mail address again, simply ignore this e-mail and continue using your old e-mail address.<br>\n<br>\nHowever, if you'd like to use a new e-mail address for your XING account, please click on the following link:<br>\n{account_reset_link}\n<br>\nIf the link doesn't work, just copy and paste it into the address bar of your browser and hit enter.",
    UVP_EMAIL_PROCESS_DECLINED_SUBJECT:
      'Your XING profile still requires verification',
    UVP_EMAIL_PROCESS_DECLINED_TEXT:
      "Unfortunately we're unable to grant you access to your profile. There may be several reasons for this:<br>\n<br>\n- Instead of uploading a document you have uploaded an image of your person<br>\n- There is no date of birth listed in your document<br>\n- Your date of birth isn't identical <br>\n- You can't be clearly identified based on the uploaded document<br>\n<br>\nPlease check to see if one of the above reasons applies to you and bear them in mind when uploading documents again. If you don't think that any of the above applies, please get in touch with us via zugang@xing.com and send us several items of information listed in your profile so we can verify that it's your profile.<br>\n<br>",
    UVP_EMAIL_RESET_ALERT_SUBJECT:
      'An attempt has been made to reset the e-mail address linked to your account.',
    UVP_EMAIL_RESET_ALERT_TEXT:
      "You can ignore this e-mail if you tried to reset your e-mail address yourself.<br>\n<br>\nIf you didn't try to reset your e-mail yourself, please contact our support team:<br>\n{support_link}",
    UVP_EMAIL_TAB: "Can't log in to your e-mail?",
    UVP_ENTER_CODE_HERE: 'Enter code here',
    UVP_ENTER_CODE_HERE_DESC:
      '...to the mobile number <strong>{phone}</strong>. Please enter the code contained in this SMS in the field below to reset your password:',
    UVP_IDENTITIY_CHECK_SUBMIT: 'Send identification details',
    UVP_IDENTITY_CARD_LABEL: 'Upload document',
    UVP_IDENTITY_CHECK_DESCRIPTION:
      'We want to make sure that only you have access to your personal data, which is why we now need to verify your identity:<br><br>\n<strong>1. Take a photo of your driving licence or health insurance card.</strong><br> \nJust click on "take photo" and hold your driving licence or health insurance card in front of your webcam.<br> \nIf you don\'t have a webcam, take a photo, save it on your computer and click on "select file" to upload it here.)<br><br>\n<strong>N.B.:</strong>The photo of your driving licence or health insurance card must show a photo of you, your name and your date of birth. (You may need to take photos of both sides.) \nPlease <strong>don\'t</strong> send us a photo of your ID card or passport as German law prohibits us from receiving them digitally.<br><br>\n\n<strong>2. Enter your new e-mail address.</strong><br>\nThis is the e-mail address you\'d like to use to log in to XING from now on. Finally, click on "send identification details".',
    UVP_IDENTITY_CHECK_HEADLINE: 'Please verify your identity',
    UVP_NEW_EMAIL_CONFIRM_LABEL: 'Confirm your new e-mail address:',
    UVP_NEW_EMAIL_LABEL: 'New e-mail address:',
    UVP_NEW_EMAIL_PLACEHOLDER: 'e.g. john.doe@new-address.com"',
    UVP_NO_SMS_RECEIVED: 'Not received an SMS?',
    UVP_PASSWORD_LOST_SUBJECT: 'XING: Your login',
    UVP_PASSWORD_LOST_TEXT:
      "We've received a request to reset your XING password.<br>\n<br>\nIf you didn't submit this request or if you've remembered your password in the meantime, you can simply ignore this message and carry on using your old password.<br>\n<br>\nIf you'd like to create a new password, please make sure you activate cookies for XING in your browser and then click on the following link:<br>\n{reset_token_link}\n<br>\nIf this link doesn't work, just copy it into your browser's address bar and press enter.",
    UVP_PASSWORD_RESET_SMS_CONFIRM_TEXT:
      '{code} is your XING password recovery code.',
    UVP_PASSWORD_RESET_SUCCESS_MAIL_SUBJECT: 'Your password has been reset.',
    UVP_PASSWORD_RESET_SUCCESS_MAIL_TEXT:
      "Your password has been reset.\n\nIf you didn't do this, please get in touch with our support team:\n{support_link}",
    UVP_PASSWORDHTML_REQUEST_SENT:
      "Please check your inbox as we've sent an e-mail to the e-mail address you linked to your XING profile (provided you entered one there). When you click on the link in the e-mail, you'll be automatically forwarded to a page explaining how to create your new password. \n<br><br>\n<strong>Haven't received an e-mail yet?</strong> Please check your spam folder and make sure our e-mail hasn't ended up there. If don't receive our e-mail within 2 hours, please <a href=\"{support_link}\">contact us</a>.",
    UVP_PROFILE_SEARCH_TAB: 'Forgotten your e-mail address?',
    UVP_PROFILE_SEARCH_TAB_WITH_PHONE: 'Forgotten your login details?',
    UVP_PROFILE_URL_ACCESS_DESCRIPTION:
      "<strong>How to find out which e-mail address you used to register on XING:</strong><br>\nFirst of all, please check which e-mail address you use to receive notifications from.<br><br>\n<strong>How to find out which mobile number you used to register on XING:<strong><br>\nThe mobile number you used to register on XING is the one via which you received your XING activation code SMS.<br><br>\nIf that doesn't work, please enter the link to your XING profile here.<br><br>\n<strong>How to find your XING profile:</strong> Search for your name together with the word XING in Google or your preferred search engine. If that doesn't work, e.g. if your profile is only visible to logged-in members, you can ask a XING member you know to visit your profile and copy the link (URL) from the address bar.",
    UVP_PROFILE_URL_ACCESS_DESCRIPTION_WITH_PHONE:
      "First of all, please check which e-mail address you use to receive messages from XING or which mobile number you used to receive an activation code SMS, then try and log in to XING with that e-mail address/mobile number.<br><br>\nIf that doesn't work, please enter the link to your XING profile here.<br><br>\n<strong>How to find your XING profile:</strong> Search for your name together with the word XING in Google or your preferred search engine. If that doesn't work, e.g. if your profile is only visible to logged-in members, you can ask a XING member you know to visit your profile and copy the link (URL) from the address bar.",
    UVP_PROFILE_URL_ACCESS_HEADLINE:
      'Not sure which e-mail address you used to register on XING?',
    UVP_PROFILE_URL_ACCESS_HEADLINE_WITH_PHONE:
      'Not sure which e-mail address/mobile number you used to register on XING?',
    UVP_PROFILE_URL_LABEL: 'Link to XING profile:',
    UVP_PROFILE_URL_PLACEHOLDER: 'e.g. https://www.xing.com/profile/John_Doe',
    UVP_RESET_SMS_SENT: 'We just sent an SMS...',
    UVP_SMS_WRONG_CODE:
      "Sorry, that wasn't the right code. Please check it again.",
    UVP_STARTPAGE_DESCRIPTION:
      'No problem! Just select one of the following two options:',
    UVP_STARTPAGE_DESCRIPTION_THREE_OPTIONS:
      "We're happy to help. Please choose one of the following two options:",
    UVP_STARTPAGE_FORGOT_EMAIL_CTA: 'Add a new e-mail address',
    UVP_STARTPAGE_FORGOT_EMAIL_DESCRIPTION:
      "<strong>Not sure which e-mail address you used to register on XING?</strong><br>\nPlease check which e-mail address you use to receive messages from XING as that's the correct address.<br><br>\n<strong>Are you experiencing any other problems?</strong><br>\nJust add a new e-mail address for XING via the following steps:",
    UVP_STARTPAGE_FORGOT_EMAIL_OR_PHONE_CTA: 'Edit login details',
    UVP_STARTPAGE_FORGOT_EMAIL_OR_PHONE_DESCRIPTION:
      "<strong>Not sure which e-mail address you used to register on XING?</strong><br>\nPlease check which e-mail address you use to receive messages from XING as that's the correct address.<br><br>\n<strong>Not sure which mobile number you used to register on XING?</strong><br>\nPlease check which number you used to receive your XING activation code SMS.<br><br>\n<strong>Are you experiencing any other problems?</strong><br>\nJust add a new e-mail address for XING via the following steps:",
    UVP_STARTPAGE_FORGOT_PW_CTA: 'Reset password',
    UVP_STARTPAGE_FORGOT_PW_PLACEHOLDER: 'e.g. john.smith@example.com',
    UVP_STARTPAGE_FORGOT_PW_PLACEHOLDER_WITH_PHONE:
      'e.g. example@example.com or +447751123456789',
    UVP_STARTPAGE_HEADLINE: 'Having problems logging in?',
    UVP_STARTPAGE_SUPPORT_PAGE_DESCRIPTION:
      "We're happy to help! Just send us a message containing as much detail about your problem as possible.",
    UVP_STARTPAGE_SUPPORT_PAGE_HEADLINE:
      'Are you having any other problems logging in to your XING profile?',
    UVP_STARTPAGE_SUPPORT_PAGE_LINK: 'Go to Help Centre',
    UVP_USER_CARE_MESSAGE_HEADLINE: 'Thanks for your enquiry!',
    UVP_USER_CARE_MESSAGE_TEXT:
      'Our User Care team will look into your request.',
    UVP_VERIFY_E_MAIL_CONFIRM_MESSAGE:
      "The e-mail addresses don't match. Please make sure your new e-mail address matches your confirmation address exactly.",
    UVP_VERIFY_E_MAIL_MESSAGE: 'Please enter your e-mail address.',
    UVP_VERIFY_IMAGE_SIZE_MESSAGE:
      'Sorry, this image is too big. Please choose an image with a smaller file size.',
    UVP_VERIFY_IMAGES_MESSAGE:
      'Please upload a scan of one of the above documents or use your webcam to take a photo.',
    UVP_VERIFY_NEW_MAIL_ERROR:
      'This e-mail address is already in use. Please choose another one.',
    UVP_VERIFY_NEW_MAIL_OR_PHONE_ERROR:
      'This e-mail address or mobile number is already activated – but you can activate a new one if you like.',
    UVP_WEBCAM_ERROR_DESCRIPTION:
      "Unfortunately we can't detect your webcam. Perhaps you don't have Adobe Flash Player installed? Please also check your browser's security settings and grant it access to your webcam.",
    UVP_WEBCAM_ERROR_HEADLINE: 'Connection error',
    UVP_WEBCAM_SNAPSHOT_CTA: 'Take photo',
    UVP_WEBCAM_SNAPSHOT_LABEL:
      'Take a photo of your document with your webcam:',
    VERTICAL_NAVIGATION_COMPANIES: 'Companies',
    VERTICAL_NAVIGATION_FOOTER_ADVERTISE: 'Advertise on XING',
    VERTICAL_NAVIGATION_FOOTER_ANDROID: 'Android',
    VERTICAL_NAVIGATION_FOOTER_ANSCHREIBEN: 'Cover letter editor',
    VERTICAL_NAVIGATION_FOOTER_APP_GALLERY: 'Mobile & desktop apps',
    VERTICAL_NAVIGATION_FOOTER_APPS: 'Apps',
    VERTICAL_NAVIGATION_FOOTER_BEWERBUNG: 'Job application tips',
    VERTICAL_NAVIGATION_FOOTER_CAREER: 'Careers',
    VERTICAL_NAVIGATION_FOOTER_CAREER_GUIDE: 'Career Guide',
    VERTICAL_NAVIGATION_FOOTER_COACHES: 'Coaches + Trainers',
    VERTICAL_NAVIGATION_FOOTER_COMPANIES: 'Companies',
    VERTICAL_NAVIGATION_FOOTER_COMPANY: 'Company',
    VERTICAL_NAVIGATION_FOOTER_DEVBLOG: 'Devblog',
    VERTICAL_NAVIGATION_FOOTER_HALLO_FREELANCER: 'Freelancer verwalten',
    VERTICAL_NAVIGATION_FOOTER_HELP: 'Help & Contact',
    VERTICAL_NAVIGATION_FOOTER_IMPRINT: 'About this site',
    VERTICAL_NAVIGATION_FOOTER_INVESTOR_RELATIONS: 'Investor Relations',
    VERTICAL_NAVIGATION_FOOTER_IPHONE_IPAD: 'iPhone & iPad',
    VERTICAL_NAVIGATION_FOOTER_JOBS_DIRECTORY: 'Jobs Directory',
    VERTICAL_NAVIGATION_FOOTER_KUNUNU: 'Employers',
    VERTICAL_NAVIGATION_FOOTER_LEBENSLAUF: 'CV editor',
    VERTICAL_NAVIGATION_FOOTER_MEMBERSHIP_ADMINISTRATION: 'Manage memberships',
    VERTICAL_NAVIGATION_FOOTER_MEMBERSHIP_CANCELLATION: 'Cancel membership',
    VERTICAL_NAVIGATION_FOOTER_MEMBERSHIPS: 'Memberships',
    VERTICAL_NAVIGATION_FOOTER_NEW_WORK_EXPERIENCE:
      'NWX – Neues zur Zukunft der Arbeit',
    VERTICAL_NAVIGATION_FOOTER_NEWWORKSE: 'New Work SE',
    VERTICAL_NAVIGATION_FOOTER_PEOPLE_DIRECTORY: 'Member directory',
    VERTICAL_NAVIGATION_FOOTER_PRAKTIKUM_GUIDE: 'Praktikum-Guide',
    VERTICAL_NAVIGATION_FOOTER_PREMIUM_MEMBERSHIP: 'Premium',
    VERTICAL_NAVIGATION_FOOTER_PRESS: 'Press',
    VERTICAL_NAVIGATION_FOOTER_PRIVACY: 'Privacy at XING',
    VERTICAL_NAVIGATION_FOOTER_PRIVACY_POLICY: 'Privacy Policy',
    VERTICAL_NAVIGATION_FOOTER_PROJOBS_MEMBERSHIP: 'ProJobs',
    VERTICAL_NAVIGATION_FOOTER_RESOURCES: 'Resources',
    VERTICAL_NAVIGATION_FOOTER_TALENT_MANAGER: 'Recruiting with XING',
    VERTICAL_NAVIGATION_FOOTER_TANDC: 'Terms & Conditions',
    VERTICAL_NAVIGATION_FOOTER_XAS: 'Post an ad',
    VERTICAL_NAVIGATION_FOOTER_XING_NEWS: 'XING News',
    VERTICAL_NAVIGATION_FOOTER_YOUR_XING: 'Main Sections',
    VERTICAL_NAVIGATION_HEADER_BRAND_MANAGER_EDITOR: 'BrandManager',
    VERTICAL_NAVIGATION_HEADER_HELP: 'Help',
    VERTICAL_NAVIGATION_HEADER_MANAGE_JOBS: 'Job ads',
    VERTICAL_NAVIGATION_HEADER_PERSONAL_ADS: 'AdManager',
    VERTICAL_NAVIGATION_HEADER_PERSONAL_COACH_PROFILE: 'Coach profile',
    VERTICAL_NAVIGATION_HEADER_PERSONAL_LOGOUT: 'Log out',
    VERTICAL_NAVIGATION_HEADER_PERSONAL_MEMBERSHIPS_INVOICES:
      'Memberships & invoices',
    VERTICAL_NAVIGATION_HEADER_PERSONAL_PREMIUM_MEMBERSHIP: 'Premium',
    VERTICAL_NAVIGATION_HEADER_PERSONAL_PROJOBS_MEMBERSHIP: 'ProJobs',
    VERTICAL_NAVIGATION_HEADER_PERSONAL_SETTINGS: 'Settings',
    VERTICAL_NAVIGATION_HEADER_SEAT_MANAGER_ADMIN: 'LicenceManager',
    VERTICAL_NAVIGATION_HEADER_XTM: 'TalentManager',
    VERTICAL_NAVIGATION_MESSAGES: 'Messages',
    WELCOME_AD_LOADING: 'Loading homepage...',
    WELCOME_APP_HEADER_LOGIN_PASSWORD_LOST: 'Having problems logging in?',
    WELCOME_APP_MINIREG_DISALLOWED_DOMAIN:
      "Your e-mail address seems to be incorrect. Maybe there's a typo?",
    WELCOME_APP_MINIREG_ERROR_BLACKLIST_LICENSE_COMPANY_MATCH:
      'Would you like to showcase your company on XING? That\'s great: Go ahead and <a href="https://recruiting.xing.com/e-recruiting-loesungen/employerbranding?sc_o=welcome_signup_error_companies_suggestion" target="_blank">create a XING Page for your company</a>.',
    WELCOME_APP_MINIREG_ERROR_BLACKLIST_LICENSE_MATCH:
      'Unfortunately you can\'t sign up with the details you\'ve entered. If you have questions about this, feel free to <a href="https://www.xing.com/support/contact/registration/confirm_registration">get in touch</a>.',
    WELCOME_APP_MINIREG_ERROR_EMAIL:
      'Please check the e-mail address you entered.',
    WELCOME_APP_MINIREG_ERROR_FIRST_NAME: 'Please enter your first name here.',
    WELCOME_APP_MINIREG_ERROR_LAST_NAME: 'Please enter your last name here.',
    WELCOME_APP_MINIREG_ERROR_PASSWORD_EMAIL:
      'For your own security you should choose a password different to your e-mail address.',
    WELCOME_APP_MINIREG_ERROR_PASSWORD_FIRST_NAME:
      'For your own security you should choose a password different to your first name.',
    WELCOME_APP_MINIREG_ERROR_PASSWORD_LAST_NAME:
      'For your own security you should choose a password different to your last name.',
    WELCOME_APP_MINIREG_ERROR_PASSWORD_TOO_LONG:
      'Please choose a password containing no more than 1,024 characters.',
    WELCOME_APP_MINIREG_ERROR_PASSWORD_TOO_SHORT:
      'Please select a password (min. 8 characters).',
    WELCOME_APP_MINIREG_ERROR_PHONE: 'Please check your phone number.',
    WELCOME_APP_MINIREG_ERROR_TANDC:
      'Please confirm that you accept the Terms & Conditions and the Privacy Policy.',
    WELCOME_LOGIN_FORM_EMAIL_REQUIRED_ERROR:
      'Please enter your e-mail address here.',
    WELCOME_LOGIN_FORM_FIRSTNAME_REQUIRED_ERROR:
      'Please enter your first name here.',
    WELCOME_LOGIN_FORM_LASTNAME_REQUIRED_ERROR:
      'Please enter your last name here.',
    WELCOME_LOGIN_FORM_PASSWORD_REQUIRED_ERROR:
      'Please enter your password here.',
    WELCOME_LOGIN_FORM_PASSWORD_REQURED_ERROR:
      'Please enter your password here.',
    WELCOME_LOGIN_FORM_REMEMEMBER_ME_LABEL: 'Remember me',
    WELCOME_LOGIN_FORM_SUBMIT_REQUEST_ERROR:
      'Sorry, something went wrong. Please try again.',
    WELCOME_LOGIN_FORM_USERNAME_REQUIRED_ERROR:
      'Please enter your e-mail address.',
    WELCOME_LOGIN_HEADLINE: 'Welcome back!',
    WELCOME_LOGIN_PASSWORD_LABEL: 'Password',
    WELCOME_LOGIN_PROBLEMS_LOGGING_IN: 'Having problems logging in?',
    WELCOME_LOGIN_SUBMIT_LABEL: 'Log in',
    WELCOME_LOGIN_USERNAME_LABEL: 'E-mail',
    WELCOME_REGISTRATION_DATAPROTECTION_LABEL: 'Privacy Policy',
    WELCOME_REGISTRATION_DATAPROTECTION_LINK:
      'https://privacy.xing.com/en/privacy-policy',
    WELCOME_REGISTRATION_EMAIL_LABEL: 'E-mail',
    WELCOME_REGISTRATION_FIRSTNAME_LABEL: 'First name',
    WELCOME_REGISTRATION_HEADLINE: 'Get your free XING profile now:',
    WELCOME_REGISTRATION_IGNORE_SOFT_EMAIL_ERRORS_LABEL:
      'Yes, {email} is the right e-mail address.',
    WELCOME_REGISTRATION_LASTNAME_LABEL: 'Last name',
    WELCOME_REGISTRATION_PASSWORD_LABEL: 'Password',
    WELCOME_REGISTRATION_RECAPTCHA_HEADLINE: 'Nearly done!',
    WELCOME_REGISTRATION_RECAPTCHA_PARAGRAPH:
      "We need to make sure you're a real person to protect you and others from spam.",
    WELCOME_REGISTRATION_SECONDARY_EMAIL_ERROR:
      'This e-mail address is already in use with a different account. Do you really want to register as a new member?',
    WELCOME_REGISTRATION_SKIP_SECONDARY_EMAIL_CHECK:
      "Yes, I'd like to register as a new member using the e-mail address {email}",
    WELCOME_REGISTRATION_SOFT_EMAIL_ERROR:
      'Please check your e-mail address again.',
    WELCOME_REGISTRATION_SUBMIT_LABEL: 'Continue',
    WELCOME_REGISTRATION_TANDC_DESCRIPTION:
      "I accept XING's {tandc} and acknowledge the {dataprotection}.",
    WELCOME_REGISTRATION_TANDC_LABEL: 'GTC',
    WELCOME_REGISTRATION_TIMER_CAPTCHA_BUTTON:
      'Press and hold me for 5 seconds',
    WELCOME_REGISTRATION_TIMER_CAPTCHA_ERROR:
      "That didn't work. Please press and hold the button again for 5 seconds.",
    WELCOME_REGISTRATION_TIMER_CAPTCHA_HEADLINE: 'One last thing',
    WELCOME_REGISTRATION_TIMER_CAPTCHA_PARAGRAPH:
      "To make sure you're a real person and not a bot, please press and hold the button below for 5 seconds.",
    WELCOME_REGISTRATION_VIA_CV_BAD_FILE_ERROR_LABEL:
      'Your file is either too big or in an unsupported format. We recommend PDF files.',
    WELCOME_REGISTRATION_VIA_CV_BUTTON_LABEL: 'Upload CV',
    WELCOME_REGISTRATION_VIA_CV_COMMON_ERROR_LABEL:
      "That didn't work. Please try again.",
    WELCOME_REGISTRATION_VIA_CV_DESCRIPTION_DEFAULT:
      'Submit your CV now and we will provide you with personalized job recommendations.',
    WELCOME_REGISTRATION_VIA_CV_DESCRIPTION_SUCCESS:
      "We've added your CV details to your XING profile. {br}{br} Please make sure everything is okay and add any information that's missing.",
    WELCOME_REGISTRATION_VIA_CV_FILE_INFO_LABEL:
      'Supported formats: PDF, Word (DOCX) or Pages (max. 100 MB)',
    WELCOME_REGISTRATION_VIA_CV_HEADLINE_DEFAULT: 'Let recruiters come to you',
    WELCOME_REGISTRATION_VIA_CV_HEADLINE_SUCCESS: 'Your CV',
    WELCOME_SIGNUP_FORM_SUBMIT_REQUEST_ERROR:
      'Sorry, something  went wrong. Please try again.',
    WELCOME_SIGNUP_FORM_VALIDATE_REQUEST_ERROR:
      'Sorry, something  went wrong. Please try again.',
    WELCOME_STARTPAGE_PROCEED_WITH_APPLE_BUTTON: 'Continue with Apple',
    WELCOME_STARTPAGE_PROCEED_WITH_GOOGLE_BUTTON: 'Continue with Google',
    X_UI_HEADER_REGISTER: 'Sign up',
    X_UI_NAVIGATION_LOGIN_FRAME_FALLBACK: 'Log in',
    X_UPGRADE_FEATURE_LINK_LOGGED_OUT:
      'Log in to see an overview of available features',
    XE_SIGN_UP_FOR_FREE: 'Sign up now for free!',
    XWS_100_GADGET_FORGOT_LOGIN: 'Forgot your login details?',
    XWS_100_GADGET_LOGIN_FAILED_INFO:
      'Your username/e-mail address or your password is incorrect.',
    XWS_100_GADGET_PASSWORD: 'Password',
    XWS_100_GADGET_USERNAME: 'Username',
    XWS_100_LOGIN_WITH_XING_CREDENTIALS:
      'Please sign in with your XING login details to grant the {application_name} app access to your XING data.',
    XWS_100_NOT_MEMBER_YET: 'Not joined XING yet?',
    XWS_100_SIGN_IN: 'Log in',
    XWS_ERROR_LOGIN_COOKIE:
      'You need to allow/activate XING\'s cookies in your browser in order to log in. To find out how to do that, just search for "cookies" in your browser\'s help section.',
  },
};
